import HeaderMain from "../comp/head-navs-main";
import ViewContent from "../comp/view-content";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import RoomViewModule from "../comp/room-view";
import RoomTextListModule from "../comp/room-text-list";
import RoomTextEnterModule from "../comp/room-text-enter";

export default function RoomView() {


  return (
    <>
      <HeaderMain />
      <ViewContent 
        content={
          <>
            <ViewDividerSmall />
            <RoomViewModule />

            <ViewDividerSmall />
            <RoomTextListModule />

            <ViewDividerSmall />
            <RoomTextEnterModule/>
          </>
        }
      />
      

    </>
  )
}